import { computed, watch, watchEffect } from "vue";
import { useBreadcrumbStore } from "@/stores/BreadcrumbStore";

export function usePageTitle(route, auth) {
  const breadcrumbs = useBreadcrumbStore();

  // Query changes can switch tabs within the same record without reloading it.
  watch(
    () => route.value.path,
    () => breadcrumbs.clearValue(),
    { flush: "sync" },
  );

  const pageTitle = computed(() => {
    const current = route.value;
    if (!current.meta?.public && !auth.isLoggedIn) return "Login";

    const crumbs = current.meta?.breadcrumbs || [];
    const recordName = String(breadcrumbs.getValue ?? "").trim();
    if (recordName && crumbs.some((crumb) => crumb.value === true)) {
      const trailingLabels = crumbs
        .slice(crumbs.findIndex((crumb) => crumb.value === true) + 1)
        .map((crumb) => crumb.name)
        .filter(Boolean);
      return [recordName, ...trailingLabels].join(" - ");
    }

    return current.meta?.title || current.meta?.navLabel || "Dashboard";
  });

  watchEffect(() => {
    document.title = `${pageTitle.value} - Neptune`;
  });

  return pageTitle;
}
